module.exports = __webpack_public_path__ + "static/media/vanity square sink front.e7018b19.jpg";